import { holidaySetting, day } from './options';

/**
 * 获取两个时间之间有多少天
*/
export const diffBetweenDates = (startTime, endTime) => {
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);

    // 确保日期是有效的
    if (isNaN(startDate) || isNaN(endDate)) {
        throw new Error("Invalid date");
    }

    // 计算日期差异（以毫秒为单位），然后转换为天数
    const timeDiff = endDate - startDate;
    const diffInDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    return diffInDays;
};

/**
 * 获取当前日期在今年的第几周
*/
const getWeekNumber = (date) => {
    const d = new Date(date);
    const n = (d.getDay() + 6) / 7;
    const yearStart = new Date(d.getFullYear(), 0, 1);
    const weekNo = Math.ceil((((d - yearStart) / 86400000) + n) / 7);
    return weekNo;
}

/**
 * 获取两个时间之间有多少周
*/
export const parseWeekBydate = (start, end, type) => {
    const startWeek = getWeekNumber(start);
    const endWeek = getWeekNumber(end);

    const startYear = new Date(start).getFullYear();
    const endYear = new Date(end).getFullYear();

    const yearDiffrentWeek = (endYear - startYear) * 52;

    const diffrentWeek = (endWeek + yearDiffrentWeek) - startWeek;

    if (type === 'left') {
        const day = new Date(end).getDay();
        const sur = Number(Number(day / 7).toFixed(2));
        console.log(diffrentWeek, sur, diffrentWeek + sur);
        return diffrentWeek + sur;
    }

    if (type === 'width') {
        const day = diffBetweenDates(start, end);
        const sur = Number(Number(day / 7).toFixed(2));
        return sur
    }
};

/**
 * 获取两个时间之间有多少个月
*/
export const parseMonthBydate = (start, end, type) => {
    // const day = diffBetweenDates(start, end);
    // let month = null;
    // if (day > 365) {
    //     const year = Math.round(day / 365);
    //     const residueDay = day - (year * 365);
    //     month = (year * 12) + Math.round(residueDay / 30);
    // } else {
    //     month = Math.round(day / 30);
    // }
    // return month - 1 < 0 ? 1 : month;

    const startDate = new Date(start);
    const endDate = new Date(end);

    const startMonth = startDate.getMonth() + 1;
    const endMonth = endDate.getMonth() + 1;

    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();

    const yearDiffrentMonth = (endYear - startYear) * 12;

    if (type === 'left') {
        const day = endDate.getDate();
        const sur = Number(Number(day / 30).toFixed(2));

        return (endMonth + yearDiffrentMonth) - startMonth + sur;
    }

    if (type === 'width') {
        const day = diffBetweenDates(start, end);
        const sur = Number(Number(day / 30).toFixed(2));
        return sur
    }

    // return (endMonth + yearDiffrentMonth) - startMonth;
}

/**
 * 补零
*/
const supplyZero = (num) => {
    num = Number(num);
    const zeroFill = num < 10 ? `0${num}` : num;
    return zeroFill;
};

const setWeekend = (year, month, dayList) => {
    const symbolList = [...dayList];

    // 月份第一天
    const monthFirstDay = new Date(`${year}-${month}-01`).getDay();


    // 月份第一天距离周六还有几天
    const diffrentSaturday = 6 - monthFirstDay;

    // 月份第一个周末
    const firstSaturday = diffrentSaturday;
    const firstSunday = firstSaturday + 1;

    // 周末下标记录
    const weekendList = [];

    for (let i = 0; i < 4; i += 1) {
        // 周末下标
        const multipleSaturday = firstSaturday + (i * 7);
        const multipleSunday = firstSunday + (i * 7);

        if (multipleSaturday < symbolList.length - 1) {
            symbolList[multipleSaturday] = '六';
            weekendList.push(multipleSaturday);
        }
        if (multipleSunday < symbolList.length - 1) {
            symbolList[multipleSunday] = '日';
            weekendList.push(multipleSunday);
        }
    }

    return {
        symbolList,
        weekendList
    }
};

const setHoliday = (year, month, symbolList, weekendList) => {
    const [includeYear] = holidaySetting.filter((f) => f.year == year);

    if (!includeYear) return { symbolList, weekendList }

    const [includeMonth] = includeYear.day.filter((f) => {
        // 假期开始时间
        const startMonth = new Date(f.start).getMonth() + 1;
        const endtDateMonth = new Date(f.end).getMonth() + 1;

        return (month == startMonth || endtDateMonth == month);
    });

    if (includeMonth) {
        const { classFill, start, durationDate } = includeMonth;
        const time = new Date(start).getTime();
        for (let i = 0; i < durationDate; i += 1) {
            const holidayTime = time + (i * day);
            const holiday = new Date(holidayTime);
            const holidayMonth = holiday.getMonth() + 1;

            if (holidayMonth == month) {
                const holidate = holiday.getDate();

                symbolList[holidate - 1] = '假';
                weekendList.push(holidate - 1);
            }
        }

        if (classFill) {
            classFill.forEach((fillTime) => {
                const fill = new Date(fillTime);
                const fillMonth = fill.getMonth() + 1;

                if (fillMonth == month) {
                    const filldate = fill.getDate();

                    symbolList[filldate - 1] = '补';
                    weekendList = weekendList.filter((f) => f !== filldate - 1);
                }
            });
        }
    }
    weekendList = weekendList.sort((a, b) => a - b);


    return {
        symbolList,
        weekendList
    }
};

// 设置 周末、假期、补班 符号
const setSymbol = (year, month, dayList) => {
    const symbol = setWeekend(year, month, dayList);

    const { symbolList, weekendList } = setHoliday(year, month, symbol.symbolList, symbol.weekendList);

    return {
        symbolList,
        weekendList
    };
};

/**
 * 获取某一年中每个月有多少天
*/
const getMonthDay = (year, month) => {
    const oneDay = 1000 * 60 * 60 * 24;

    const startMonth = month < 9 ? `0${month}` : month;
    const endMonth = month + 1 < 9 ? `0${month + 1}` : month + 1;

    const startDate = `${year}-${startMonth}-01`;

    const endDate =
        month + 1 > 12 ? `${year + 1}-01-01` : `${year}-${endMonth}-01`;

    const startTime = new Date(startDate).getTime();
    const endTIme = new Date(endDate).getTime();

    const day = Math.round((endTIme - startTime) / oneDay);

    const dayList = [];

    for (let index = 0; index < day; index += 1) {
        dayList.push(index + 1);
    }

    const symbolList = setSymbol(year, month, dayList);

    return symbolList;
};

const getDay = (list) => {
    list.forEach((item) => {
        const { year, startMonth, endMonth } = item;
        const children = [];
        let dayNum = 0;
        for (let index = startMonth; index <= endMonth; index += 1) {
            // const dayList = getMonthDay(year, index);
            const { symbolList, weekendList } = getMonthDay(year, index);
            children.push({
                month: index,
                dayList: symbolList,
                weekendList,
            });
            dayNum += symbolList.length;
        }
        item.children = children;
        item.dayNum = dayNum;
    });

    // console.log(list, 'header data is ?');

    return list;
};

const getWeek = (year, startMonth, endMonth) => {
    let startWeek = null;
    let endWeek = null;

    const sWeek = `${year}-01-01`;

    if (startMonth === 1) {
        startWeek = 1;
    }

    if (endMonth === 12) {
        endWeek = 52;
    }

    if (startMonth > 1) {
        // startWeek = parseWeekBydate(sWeek, `${year}-${supplyZero(startMonth)}-01`);
        startWeek = getWeekNumber(`${year}-${supplyZero(startMonth)}-01`);
    }

    if (endMonth < 12) {
        // endWeek = parseWeekBydate(sWeek, `${year}-${supplyZero(endMonth)}-28`);
        endWeek = getWeekNumber(`${year}-${supplyZero(endMonth)}-28`);
    }

    return {
        startWeek,
        endWeek
    }
};


const getYear = (startDate, endDate, mode) => {
    const yearList = [];
    const startYear = new Date(startDate).getFullYear();
    const entYear = new Date(endDate).getFullYear();

    for (let index = 0; index <= entYear - startYear; index += 1) {

        const year = startYear + index;
        const startMonth =
            index === 0 ? new Date(startDate).getMonth() + 1 : 1;
        const endMonth =
            index === entYear - startYear
                ? new Date(endDate).getMonth() + 1
                : 12;


        const { startWeek, endWeek } = getWeek(year, startMonth, endMonth);

        let start = null;
        let end = null;

        switch (mode) {
            case 'week':
                start = startWeek;
                end = endWeek;
                break;
            case 'month':
                start = startMonth;
                end = endMonth;
                break;
            default:
                break;
        }

        yearList.push({
            year,
            startMonth,
            endMonth,
            startWeek,
            endWeek,
            start,
            end
        });


    }
    return yearList;
};

// 获取甘特图表头
export const getGanntHeader = (startTime, endTime, mode) => {
    let header = null;
    const year = getYear(startTime, endTime, mode);

    switch (mode) {
        case 'day':
            header = getDay(year, mode);
            break;
        case 'week':
            header = year;
            break;
        case 'month':
            header = year;
            break;
        default:
            break;
    }

    return header
};

export const compareTime = (a, b, type) => {
    if (b === null) {
        return a;
    }
    if (a === null) {
        return b;
    }
    if (type === "max") {
        return new Date(a) > new Date(b) ? a : b;
    } else if (type === "min") {
        return new Date(a) > new Date(b) ? b : a;
    }
};

/**
 * 获取列表中日期最大或最小的日期
*/
export const getMinOrMaxDateBylist = (list, type) => {
    let time = null;
    list.forEach((date) => {
        time = compareTime(time, date, type);
    });
    return time;
};
